import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-cms-page',
  templateUrl: './cms-page.component.html',
  styleUrls: ['./cms-page.component.scss']
})
export class CmsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  
}
